import React from 'react'

import { applyStyle, formatResponsiveProps, getSmartSize } from '../helpers/styles'

export const useSizeStyle = props => {
  const { minHeight, minWidth, maxWidth, width, maxHeight, height } = formatResponsiveProps(props)

  return React.useMemo(() => {
    return `
      ${applyStyle('min-width', minWidth, getSmartSize(minWidth))}
      ${applyStyle('width', width, getSmartSize(width))}
      ${applyStyle('max-width', maxWidth, getSmartSize(maxWidth))}
      ${applyStyle('min-height', minHeight, getSmartSize(minHeight))}
      ${applyStyle('height', height, getSmartSize(height))}
      ${applyStyle('max-height', maxHeight, getSmartSize(maxHeight))}
    `
  }, [minHeight, minWidth, maxWidth, width, maxHeight, height])
}
